import { render, staticRenderFns } from "./bscAfterSalesConfirm.vue?vue&type=template&id=32020d0e&scoped=true"
import script from "./bscAfterSalesConfirm.vue?vue&type=script&lang=js"
export * from "./bscAfterSalesConfirm.vue?vue&type=script&lang=js"
import style0 from "./bscAfterSalesConfirm.vue?vue&type=style&index=0&id=32020d0e&prod&lang=css"
import style1 from "./bscAfterSalesConfirm.vue?vue&type=style&index=1&id=32020d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32020d0e",
  null
  
)

export default component.exports